/* global axios */
import ApiClient from './ApiClient';

class GoogleCalendarAPI extends ApiClient {
  constructor() {
    super('google_calendar', { accountScoped: true });
  }

  // Connection escopada por funnel — todas as operacoes precisam de funnelId.
  // POST /api/v1/accounts/:account_id/funnels/:funnel_id/google_calendar/authorizations
  connect(funnelId) {
    return axios.post(
      `${this.baseUrl()}/funnels/${funnelId}/google_calendar/authorizations`
    );
  }

  status(funnelId) {
    return axios.get(
      `${this.baseUrl()}/funnels/${funnelId}/google_calendar/connection`
    );
  }

  update(funnelId, payload) {
    return axios.patch(
      `${this.baseUrl()}/funnels/${funnelId}/google_calendar/connection`,
      payload
    );
  }

  disconnect(funnelId) {
    return axios.delete(
      `${this.baseUrl()}/funnels/${funnelId}/google_calendar/connection`
    );
  }

  syncNow(funnelId) {
    return axios.post(
      `${this.baseUrl()}/funnels/${funnelId}/google_calendar/connection/sync_now`
    );
  }

  // GET /api/v1/accounts/:account_id/google_calendar/connections
  // Diretório allowlist da conta atual. Não substitui o status por funil.
  listConnections() {
    return axios.get(`${this.url}/connections`);
  }

  getSettings() {
    return axios.get(`${this.url}/settings`);
  }

  updateSettings(payload) {
    return axios.patch(`${this.url}/settings`, payload);
  }

  // POST /api/v1/accounts/:account_id/google_calendar/authorizations
  // connection_scope=account|personal. connection_id opcional para reconectar.
  // owner_user_id nunca vai no body: o servidor deriva o dono pessoal.
  authorize({ connection_scope, connection_id } = {}) {
    const payload = { connection_scope };
    if (connection_id != null && connection_id !== '') {
      payload.connection_id = connection_id;
    }
    return axios.post(`${this.url}/authorizations`, payload);
  }

  // DELETE /api/v1/accounts/:account_id/google_calendar/connections/:id
  // Arquiva localmente. Não revoga o Google. Funil permanece no endpoint legado.
  disconnectConnection(id) {
    return axios.delete(`${this.url}/connections/${id}`);
  }

  listGrants(id) {
    return axios.get(`${this.url}/connections/${id}/grants`);
  }

  upsertGrant(id, { user_id, role } = {}) {
    return axios.post(`${this.url}/connections/${id}/grants`, {
      user_id,
      role,
    });
  }

  deleteGrant(id, grantId) {
    return axios.delete(`${this.url}/connections/${id}/grants/${grantId}`);
  }
}

export default new GoogleCalendarAPI();
